import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'
import LifeRaterPriceInsuredToSave from '@/modules/life/common/models/MID/LifeRaterPriceInsuredToSave'

//TODO: create a parent class for all RaterPriceRequest classes to avoid code duplication
export default class LifeRaterPriceRequest {
  /** (String): Identificador de la solicitud. Ejemplo: "63a075f1-f89b-4b86-8967-444baa63d30f". Obligatorio para una retarificación. */
  quotationId!: string

  /** (Integer): Número de cotización. Ejemplo: "4798669". Obligatorio para una retarificación. */
  quotationNumber!: number

  /** (String): Línea de negocio. Ejemplo: "AS00". Obligatorio para una primera tarificación. */
  businessLine!: string

  /** (DateTime): Fecha de inicio de seguro. Ejemplo: "2024-05-24". Obligatorio para una primera tarificación. */
  insuranceStartDate!: string

  /** (String): Tipo de seguro */
  insuranceType!: string

  /** (String): Código postal del titular de la póliza. Ejemplo: "28041". Obligatorio para una primera tarificación. */
  policyHolderPostal!: string

  /** (Array): Listado de asegurados. */
  insureds!: LifeRaterPriceInsuredToSave[]

  /** (Array, opcional): Listado de productos del cliente. */
  clientProduct?: RaterPriceClientProduct[]

  /** Si debe dejar registro en Senda o no */
  isQuote: boolean = false

  /** (String, opcional): Descripción de tipo de revalorizacion. */
  revaluationType?: string

  /** (String, opcional): Valor de tipo de revalorizacion. */
  revaluationValue?: string

  /** (String, opcional): Código del mediador. */
  mediator?: string

  constructor(data: any) {
    if (data.quotationId) this.quotationId = data.quotationId // must not send if its null or undefined
    this.quotationNumber = data.quotationNumber
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data.insuranceType
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds?.map((i: any) => new LifeRaterPriceInsuredToSave(i))
    this.clientProduct = data.clientProduct?.map((cp: any) => new RaterPriceClientProduct(cp))
    this.isQuote = data.isQuote
    this.revaluationType = data.revaluationType
    this.revaluationValue = data.revaluationValue
    if (data.mediator) this.mediator = data.mediator
  }
}
